import React from 'react';
interface GenericAccordianProps {
  children?: React.ReactNode;
}

const GenericAccordian = (props: GenericAccordianProps) => (
  <div style={{ backgroundColor: '#ffffff', padding: '16px', borderRadius: '4px' }}>
    {props.children}
  </div>
);
export default GenericAccordian;
